export const CHANGE_QUICK_VIEW_FIELD = 'CHANGE_QUICK_VIEW_FIELD';
export const GET_SETTING_QUICK_VIEW = 'GET_SETTING_QUICK_VIEW';
export const GET_SETTING_QUICK_VIEW_RESULT = 'GET_SETTING_QUICK_VIEW_RESULT';
export const SAVE_SETTING_QUICK_VIEW = 'SAVE_SETTING_QUICK_VIEW';
export const SAVE_SETTING_QUICK_VIEW_RESULT = 'SAVE_SETTING_QUICK_VIEW_RESULT';
export const CLEAR_DATA_QUICK_VIEW = 'CLEAR_DATA_QUICK_VIEW';
